var _linearGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsaTennesseeKenoToGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -0.168,
    y1: 0.588,
    x2: 1.094,
    y2: 0.395
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.049,
    stopColor: "#e0292a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#e0292a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#e65652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#e75c57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#e54c4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#e65352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#ea706e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#ed8582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#ee928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#ef9692"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 10.289c21.549 0 39.054 17.595 39.054 39.295S71.579 88.88 50 88.88 10.946 71.285 10.946 49.585 28.421 10.289 50 10.289z",
    fill: "#fdd946"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 18.589c17.022 0 30.784 13.883 30.784 30.996S66.992 80.55 50 80.55c-17.022 0-30.784-13.853-30.784-30.966S32.978 18.589 50 18.589z",
    fill: "#db203f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29.454c11.046 0 20.01 9.024 20.01 20.131S61.046 69.715 50 69.715s-20.01-9.024-20.01-20.131c0-11.137 8.964-20.131 20.01-20.131z",
    fill: "#fdd946"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 38.72c5.976 0 10.805 4.859 10.805 10.865 0 5.976-4.829 10.835-10.805 10.835s-10.805-4.859-10.805-10.835c0-6.006 4.829-10.865 10.805-10.865z",
    fill: "#db203f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.849 82.24c4.225 5.433 16.207 6.157 22.877 6.187v.181c-3.441 1.177-26.589 2.475-22.877-6.368z",
    fill: "#e05448"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m52.988 45.571 2.475 1.298L40.04 70.56l-2.324-1.177c1.841-9.115 6.7-16.569 15.272-23.813zM35.151 63.076c.211.241.573 3.561.573 3.561-4.648 2.505-14.879 9.598-15.513 15.453-.936 8.602 16.418 7.304 22.455 6.519v.272c-6.097 1.147-21.489 2.022-25.11-3.924-5.251-8.662 10.593-20.553 17.595-21.881z",
    fill: "#bc1d25"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.067 47.985c8.058-1.72 18.591-2.837 26.921-2.384L37.686 69.414a54.084 54.084 0 0 1-3.169-4.648c-5.312 3.32-20.191 12.344-16.901 20.221-.815-.785-3.863-7.213-4.135-8.27-2.565-9.447 7.304-19.768 14.125-25.11l-1.539-3.622z",
    fill: "url(#a)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-29 63z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaTennesseeKenoToGo);
export default __webpack_public_path__ + "static/media/usa_tennessee_keno_to_go.d7827632dbc7bef86a0b53f83c19d5c1.svg";
export { ForwardRef as ReactComponent };